

import {SorterListProps, Options, Center, Firmware, Model} from '../../types/sorter';
import axios from 'axios';
import api from "../../api/axiosClient"


export const updateSorterOptions = (setCenterOptions:React.Dispatch<React.SetStateAction<Options[]>>, setFirmwareOptions:React.Dispatch<React.SetStateAction<Options[]>>, setcolorModelOptions:React.Dispatch<React.SetStateAction<Options[]>>, setReuseModelOptions:React.Dispatch<React.SetStateAction<Options[]>>, setRecyclingModelOptions:React.Dispatch<React.SetStateAction<Options[]>>) =>{
            const options = async() =>{
                const responseCenters = await api.get(`/logistic-centers/getAll`)
                const centers = (responseCenters.data as Center[]).map(({ id, name }) => {
                      return {
                        label: name,
                        value: String(id),
                      };
                    });

                setCenterOptions(centers)
                const responseFirmwares = await api.get(`/sorter/firmware`)
                const firmwares = (responseFirmwares.data as Firmware[]).map(({ id, name }) => {
                      return {
                        label: name,
                        value: String(id),
                      };
                    });
                setFirmwareOptions(firmwares)
                

                const responseColorModels = await api.get(`/sorter/model/color-models`)
                const colorModels = (responseColorModels.data as Model[]).map(({ id, name }) => {
                      return {
                        label: name,
                        value: String(id),
                      };
                    });
                setcolorModelOptions(colorModels)

                const responseReuseModels = await api.get(`/sorter/model/reuse-models`)
                const reuseModels = (responseReuseModels.data as Model[]).map(({ id, name }) => {
                      return {
                        label: name,
                        value: String(id),
                      };
                    });
                setReuseModelOptions(reuseModels)

                const responseRecyclingModels = await api.get(`/sorter/model/recycling-models`)
                const recyclingModels = (responseRecyclingModels.data as Model[]).map(({ id, name }) => {
                      return {
                        label: name,
                        value: String(id),
                      };
                    });
                setRecyclingModelOptions(recyclingModels)
            }
          options()
  }